module.exports = __webpack_public_path__ + "img/settings.d440ffa9.svg";